<template>
  <div class="card">
    <div class="card-header flex-wrap pt-6 pb-0">
      <div class="card-title">
        <div class="card-label">
          <h3 class="card-label fs-2">{{ $t('projects.formalities') }}</h3>
        </div>
      </div>
      <div class="card-toolbar">

      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <formalities-tables v-model="tables" />
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import FormalitiesTables from "@/Modules/Projects/components/FormalitiesTables.vue";

const store = useStore()
const route = useRoute()

const tables = ref([])

onMounted(() => {
  store.dispatch('projectSteps/loadProjectTables', route.params.id).then((response) => {
    if(response.data.data) {
      tables.value = response.data.data.tables
    }
  })
})
</script>